'use client';

import { useEffect, useRef } from 'react';
import { consumeToolUsage } from '@/lib/browser-tool-usage';

// Reports `tool_used` once per mount, the first time the tool has actually produced
// something. Fire-and-forget on purpose: `consumeToolUsage` throws when the usage endpoint
// refuses, and a analytics call must never be able to break a tool that works offline.
//
// Why this hook exists: 151 of 282 Browser* components never reported usage, including
// deep-fry-image, which is the site's biggest organic winner (4790 impressions and 97 clicks
// in 14 days). A zero in the tool_used report therefore meant "not instrumented" far more
// often than "nobody used it", which quietly invalidated every read of that number.
export function useToolUsageReport(toolSlug: string, hasResult: boolean) {
  const reported = useRef(false);

  useEffect(() => {
    if (!hasResult || reported.current) return;
    reported.current = true;
    void consumeToolUsage(toolSlug, '').catch(() => undefined);
  }, [hasResult, toolSlug]);
}
